/**
 * RM-353 — someone texting FOR a member from an approved second number.
 *
 * actorByline: how RM names them ("Ben, for Jason Beghe") in the admin views
 * and the member's own RM AI chat (D7, 9/30), from
 * the actor block the server stores on each turn and activity row.
 * accessOf / accessLabel: the number's access level as RM via Text shows it.
 * 'full' texts exactly as the member; anything else is an assistant, with a
 * personal admin's limits (RM-337). The server reads it the same way.
 */

/**
 * @param {{ name?: string, email?: string, onBehalfOf?: string }|null} actor
 * @returns {string} '' when there is no one to name
 */
export function actorByline(actor) {
  const who = actor && (actor.name || actor.email)
  
  return who ? `${who}, for ${actor.onBehalfOf || 'the member'}` : ''
}

/** @returns {'full'|'assistant'} */
export function accessOf(number) {
  return number && number.access === 'full' ? 'full' : 'assistant'
}

export function accessLabel(number) {
  return accessOf(number) === 'full' ? 'Full access' : 'Assistant'
}
